import React from "react";
import { ButtonLink } from "../Common/ButtonLink";
import { Body } from "../Common/Typography";
import { ActionOptions } from "../Inputs/DropdownMenu";
import { Container, Image, TextContent } from "./__styles__/FeaturedItem";

type FeaturedItemImage = {
  url: string;
  accessibilityText: string;
};

type FeaturedItemProps = {
  image: FeaturedItemImage;
  title: string;
  description: string;
  link?: ActionOptions & {
    text?: string;
  };
};
export const FeaturedItem = ({
  image,
  title,
  description,
  link,
}: FeaturedItemProps) => {
  return (
    <Container>
      <Image src={image.url} alt={image.accessibilityText} />
      <TextContent>
        <Body size="small" type="emphasis" style={{ marginBottom: 0 }}>
          {title}
        </Body>
        <Body
          size="small"
          type="regular"
          color="contentSecondary"
          style={{ marginBottom: 0 }}
        >
          {description}
        </Body>
      </TextContent>
      {link && (
        <ButtonLink
          styleVariant="primary"
          size="small"
          rightIconName="arrow-right"
          {...link}
        >
          {link.text || "Learn more"}
        </ButtonLink>
      )}
    </Container>
  );
};
